var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48824 7.48824C7.23833 7.48872 6.99614 7.40169 6.80372 7.24224L0.38638 1.89446C0.167959 1.71291 0.0306013 1.45203 0.00452583 1.16921C-0.0215497 0.886395 0.0657924 0.604801 0.247337 0.386379C0.428882 0.167958 0.689759 0.0306014 0.972578 0.00452585C1.2554 -0.0215497 1.53699 0.0657919 1.75541 0.247337L7.48824 5.03895L13.2211 0.418467C13.3305 0.329623 13.4563 0.263277 13.5915 0.223241C13.7266 0.183206 13.8683 0.170271 14.0084 0.18518C14.1486 0.200088 14.2844 0.242546 14.4081 0.310114C14.5318 0.377682 14.6409 0.469028 14.7291 0.5789C14.8271 0.688873 14.9013 0.81789 14.947 0.957867C14.9928 1.09784 15.0092 1.24576 14.9951 1.39236C14.9811 1.53896 14.9369 1.68107 14.8653 1.8098C14.7938 1.93853 14.6965 2.0511 14.5794 2.14045L8.16206 7.30641C7.9641 7.44066 7.72685 7.50468 7.48824 7.48824Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.ce3b3fb7539c0dc28b6995e84a33f2b6.svg";
export { ForwardRef as ReactComponent };